export const UPDATE_LAYOUTS = 'UPDATE_LAYOUTS'
export const ADD_LAYOUT = 'ADD_LAYOUT'
export const REMOVE_LAYOUT = 'REMOVE_LAYOUT'
export const UPDATE_PLOTS = 'UPDATE_PLOTS'
export const REFRESH_PLOT = 'REFRESH_PLOT'
export const ADD_PLOT = 'ADD_PLOT'
export const REMOVE_PLOT = 'REMOVE_PLOT'
